<template>
  <zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >
    <z-page title="Paparan Terimaan Cek" >

      
    <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="submitTerimaan" @success="onSuccess">
        <w-card bg-color="" class="">
            <w-flex justify-center align-center>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          No Cek :
                      </h5>
                      <div class="fw-normal my1 fs-1">{{form.no_cek}} </div>
                </div>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Bank :
                      </h5>
                      <div class="fw-normal my1 fs-1">{{form.lkp_bank_keterangan_cek}} </div>
                </div>
                <div class="xs4">
                        <h5 class="fw-semibold m0">
                            Status :
                        </h5>
                        <div class="fw-normal my1 fs-1">
                            <template v-if="form.status == 0">
                                Cek Belum Jelas
                            </template>
                            <template v-else-if="form.status == 1">
                                Cek Sudah Jelas
                            </template>
                            <template v-else-if="form.status == 2">
                                Cek Tak Laku
                            </template>
                            <template v-else-if="form.status == 3">
                                Permohonan Cek Tak Laku
                            </template>
                            <template v-else>
                                
                            </template>
                        </div>
                </div>
            </w-flex>
            <w-flex justify-center align-center>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          No. Penyata Pemungut :
                      </h5>
                      <div class="fw-normal my1 fs-1">{{form.no_pemungut}} </div>
                </div>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Cara Bayaran :
                      </h5>
                      <div class="fw-normal my1 fs-1">
                            {{form.cara_bayaran_resit}}
                      </div>
                </div>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Amaun :
                      </h5>
                      <div class="fw-normal my1 fs-1"> {{$zutil.currency(form.amaun)}} </div>
                </div>
                
            </w-flex>

             <w-flex justify-center align-center>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Tarikh Cek :
                      </h5>
                      <div class="fw-normal my1 fs-1">{{$zutil.dateformat(form.tarikh_cek)}} </div>
                </div>
            <template v-if="form.status == 3 || form.status == 2">
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Tarikh Batal :
                      </h5>
                      <div class="fw-normal my1 fs-1">{{$zutil.dateformat(form.tarikh_batal)}}
                      </div>
                </div>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          Catatan Batal :
                      </h5>
                      <div class="fw-normal my1 fs-1">{{form.catatan_batal}} </div>
                </div>
            </template>
            <template v-else>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                      </h5>
                      <div class="fw-normal my1 fs-1">
                      </div>
                </div>
                <div class="xs4">
                      <h5 class="fw-semibold m0">
                          
                      </h5>
                      <div class="fw-normal my1 fs-1"> </div>
                </div>
                
            </template>
            </w-flex>
            
        </w-card>
        <br>

        
    <center v-if="loading"><w-progress class="ma1" circle></w-progress></center>
        
        <w-tabs :items="tabs" :no-slider="false" active-class="primary">  
            <template #item-content.1> 
                    <w-flex justify-center align-center>
                        <div class="w-card__content content-hardcode">
                            <table class="table-dashboard" width="100%">
                                <thead>
                                    <tr>
                                        <td>Bil.</td>
                                        <td>No. Resit</td>
                                        <td>Tarikh Resit</td>
                                        <td>Amaun (RM)</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="dat, index in form.resit">
                                        <td>{{(index+1)}}</td>
                                        <td >
                                            {{dat.no_resit}}
                                        </td>
                                        <td >
                                            {{dat.tarikh_bayaran}}
                                        </td>
                                        <td align="right">
                                            {{$zutil.currency(dat.amaun)}}
                                        </td>
                                    </tr>
                                <tr>
                                    <td colspan="3"><b>Jumlah</b></td>
                                    <td align="right">
                                        <!-- <template v-if="form.resit && form.resit.amaun"> -->
                                        <b>{{$zutil.currency(form.total)}}</b>
                                    <!-- </template> -->
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </w-flex> 
            </template>
             <template #item-content.2>
                  <w-flex justify-center align-center>
                    <div class="w-card__content content-hardcode">
                     
                        <table class="table-dashboard" width="100%">
                            <thead>
                                <tr>
                                    <td>Bil.</td>
                                    <td>Kod Akaun</td>
                                    <td>Keterangan</td>
                                    <td>Amaun (RM)</td>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="dt, index in form.butiran_akaun">
                                <td>{{(index+1)}}</td>
                                <td >
                                    {{dt.akaun_kod}} | {{dt.akaun_keterangan}}
                                </td>
                                 <td >
                                    {{dt.keterangan}}
                                </td>
                                 
                                <td align="right">
                                    {{$zutil.currency(dt.amaun)}}
                                </td>
                            </tr>
                            <tr>
                              <td colspan="3"><b>Jumlah</b></td>
                              <td align="right">
                                        <b>{{$zutil.currency(form.total)}}</b>
                                    </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </w-flex> 
            </template>


            <template #item-content.3>
                <w-flex justify-center align-center>
                  <div class="w-card__content content-hardcode">

                        <table class="table-dashboard" width="100%">
                            <thead>
                              <tr>
                                <td width="2%">No</td>
                                <td>Lampiran</td>
                                <td width="15%">Tarikh</td>
                              </tr>
                            </thead>
                            <tbody>
                                  <tr v-for="dt, index in form.lampiran">
                                      <td class="w-table__cell text-left">
                                          {{(index + 1)}}
                                      </td>
                                      <td class="w-table__cell text-left">
                                        <a :href="dt.url">
                                          {{dt.nama}}</a>
                                      </td>
                                      <td class="w-table__cell text-left">
                                          {{$zutil.dateformat(dt.created_at)}}
                                      </td>
                                  </tr>
                                   <tr v-if="form.lampiran.length == 0">
                                  <td class="w-table__cell text-left" colspan="5">
                                  </td>
                              </tr>
                              </tbody>
                        </table>
                    </div>
                </w-flex>
            <!-- </w-form> -->
          </template>

            <template #item-content.4>
                <w-flex justify-center align-center>
                  <div class="w-card__content content-hardcode">

                      <table class="table-dashboard" width="100%">
                          <thead>
                          <tr>
                              <td >No</td>
                              <td >Tindakan</td>
                              <td >Pengguna</td>
                              <td >Tarikh</td>
                              <td>Catatan</td>
                          </tr>
                          </thead>
                          <tbody>
                          
                              <tr v-for="dt, index in form.jejak_audit">
                                  <td class="w-table__cell text-left">
                                      {{(index + 1)}}
                                  </td>
                                  <td class="w-table__cell text-left">
                                      {{dt.tindakan_cek.keterangan}}
                                  </td>
                                  <td class="w-table__cell text-left">
                                      {{dt.user.name}}
                                  </td>
                                  <td class="w-table__cell text-left">
                                       {{$zutil.dateformat(dt.created_at)}} 
                                  </td>
                                  <td class="w-table__cell text-left">
                                      {{dt.catatan}}
                                  </td>
                              </tr>
                              <tr v-if="form.jejak_audit.length == 0">
                                  <td class="w-table__cell text-left" colspan="5">
                                  </td>
                              </tr>
                          </tbody>
                          
                      </table>
                    </div>
                </w-flex>
            <!-- </w-form> -->
            </template>

        </w-tabs>
        <w-flex class="mt3" wrap align-center justify-end>

                   <!--  <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent">
                        <w-icon dark tile class="mr2">fal fa-save</w-icon> KemasKini
                    </w-button> -->

                   <!--  <w-button class="my1" bg-color="error-dark1" dark  @click="BatalResit()" >
                         <w-icon dark tile class="mr2">fal fa-times</w-icon> Batal
                    </w-button> -->
                 <w-button class="my1" bg-color="warning" dark  @click="kembali()" >
                     <w-icon dark tile class="mr2">fal fa-arrow-left</w-icon> Kembali
                </w-button>
                 &nbsp;&nbsp;
                 <template v-if="form.status == 3 ">
                   <w-button class="my1" bg-color="success" dark  @click="send(1)" >
                         <w-icon dark tile class="mr2">fal fa-times</w-icon> Tidak Lulus
                    </w-button>
                    &nbsp;&nbsp;
                </template>
                <!-- <template v-if="(form.penyata_pemungut_id == null) && form.status == 3 && $zutil.can('Lulus Cek')"> -->
                <template v-if="form.status == 3 && $zutil.can('Lulus Cek')">
                   <w-button class="my1" bg-color="primary" dark  @click="send(2)" >
                         <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon> Lulus
                    </w-button>
                    &nbsp;&nbsp;
                </template>
                <!-- <template v-if="(form.penyata_pemungut_id == null)  && form.status == 0 && $zutil.can('Batal Cek')">  -->
                <!-- <template v-if="(form.penyata_pemungut_id == null)  && form.status == 1 && $zutil.can('Batal Cek')"> -->
                <template v-if="form.status == 1 && $zutil.can('Batal Cek')"> 
 
                   <w-button class="my1" bg-color="error-dark1" dark   @click="BatalCek" >
                         <w-icon dark tile class="mr2">fal fa-times</w-icon>Permohonan Cek Tak laku
                    </w-button>
                    &nbsp;&nbsp;
                </template>
                <!-- <template v-if="form.status != 2">
                    <w-button class="my1" bg-color="success" dark  @click="send(1)" >
                         <w-icon dark tile class="mr2">fal fa-save</w-icon> Sudah Clear
                    </w-button>
                    &nbsp;&nbsp;
                </template> -->
            </w-flex>

        </w-form>
  
    </z-page>

       <w-dialog
            v-model="dialog.show"
            :fullscreen="dialog.fullscreen"
            :width="dialog.width"
            :persistent="dialog.persistent"
            :persistent-no-animation="dialog.persistentNoAnimation"
            title-class="primary-light1--bg white"
        >
            <template #title>
                <w-icon class="mr2">fal fa-user</w-icon>
                Permohonan Cek Tak Laku
            </template>
            <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess"> 
               <w-flex justify-space-between class="mb4">
                   <z-input 
                        label="Ulasan Permohonan Cek Tak Laku *"  
                        name="catatan_batal" 
                        v-model="form.catatan_batal"
                        :validators="[validators.required]"/>
                    </w-flex>

               <w-flex justify-space-between class="mb4">
                        <w-input
                          class="mt3"
                            style="margin-left: 10px;"
                            type="file"
                            placeholder="Sila Muatnaik Borang Cek"
                            v-model="files"
                            label="Sila Muatnaik Gambar/Fail  *"
                        />
              </w-flex>
            </w-form>
            

            <template #actions>
                <div class="spacer" />
                  <w-button class="my1" bg-color="primary" dark  @click="send(3)" >
                         <w-icon dark tile class="mr2">fal fa-paper-plane</w-icon> Hantar
                    </w-button>
                    &nbsp;&nbsp;
                <w-button
                    bg-color="grey-light5--bg"
                    @click="dialog.show = false"
                    >Tutup</w-button
                >
            </template>
        </w-dialog>

  </zen-one>
</template>

<script>

import ZResource from '@/Modules/z-resource-service'


export default {
  extends: ZResource,
  components: {
    
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {

  
    resourceurl: this.service_kutipan +'terimaan_cek',
    reload: true,
    loading : true,
    files:[],
    dialog: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 1000,
            },

    tabs: [
          { title: 'Senarai Resit', content: '' },
          { title: 'Senarai Kod Akaun', content: '' },
          { title: 'Lampiran', content: '' },
          { title: 'Jejak Audit', content: '' },
    ],

        
    
      crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Teriaman Cek', route: '/kutipan' },
        { label: 'Papar', route: '/kutipan/'+this.id },
      ],

      
    }
  },
    methods: {

    send(status){

     // alert(status);
      this.form.status = status
      this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
                  .then(res => {
                      

                    if (typeof this.onAfterEdit === "function") {
                        this.onAfterEdit()
                      }

                    // if (this.form.status == 3) {
                        this.upload(res.id);
                    // }
                      this.$inertia.visit(this.$route('kutipan.terimaan_cek.index'))
                  })
                  .catch(err => {

                  })
                  .finally(() => {
                      

                  });
    
    },
     upload(id){
            let formData = new FormData();
            formData.append('file', this.files[0].file);
            formData.append('model', 'App\\Models\\TeriamanCek');
            formData.append('model_id', id);
            console.log(formData);
            this.$zcomm.post(this.resourceurl+'/upload', formData)
              .then(res => {
              if (typeof this.onAfterAdd === "function") {
                  this.onAfterAdd()
              }
              this.$zutil.notify ("Cek Telah Berjaya Dihantar")
            })
            .catch(err => {

            })
            .finally(() => {

            });
    },

    BatalCek() {
            this.dialog.show = 1;
    },

    kembali(){
         this.$inertia.visit(this.$route('kutipan.terimaan_cek.index'))
    },

    // getData()  {
    //       var app = this;

    //       if(this.id){
    //         if(this.id > 0){
    //           this.$zcomm.get(this.service_kutipan +'terimaan_cek/'+this.id+''+window.location.search).then(res => {
    //             this.form = res;
    //             this.cekAmaunResit();

    //           })
    //           .finally(() => {

    //             this.loading = false
    //           });
    //         }
    //       }
          
          
    //     },

    cekAmaunResit() {
            this.amaun_resit = 0;
            for (var i in this.form.resit) {
                this.amaun_resit =
                    this.amaun_resit +
                    parseFloat(this.form.resit[i].amaun);
            }
        },


   // submitTerimaan(){
   //   // alert('asssd');
   //      if (this.form.id > 0) {
   //            this.$zcomm.update(this.resourceurl + '/'+this.form.id, this.form.id, this.form)
   //                .then(res => {
                      

   //                  if (typeof this.onAfterEdit === "function") {
   //                      this.onAfterEdit()
   //                    }
   //                })
   //                .catch(err => {

   //                })
   //                .finally(() => {
                      

   //                });
   //        }
   //  },
   
  
   
    
 
  },
  watch: {

  },
  mounted() {

    if(this.id == 0){
      }

    // this.getData();
    
      
  },
    
}
</script>